export default __webpack_public_path__ + "static/media/our-process-bg-1.7ee88a0f.jpg";